import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const Event = () => {
    useDocTitle('event');

    return (
        <>
            <div className="min-h-screen flex items-center justify-center text-center">
                <h1 className="text-4xl md:text-6xl font-bold text-gray-800">
                    Coming Soon
                </h1>
            </div>
            <Footer />
        </>
    );
};

export default Event;
